// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  formDataBodySerializer,
} from '@hey-api/client-fetch'
import type {
  AuthControllerLoginData,
  AuthControllerLoginResponses,
  AuthControllerRefreshTokenData,
  AuthControllerRefreshTokenResponses,
  AuthControllerGetCurrentUserData,
  AuthControllerGetCurrentUserResponses,
  SettingsControllerGetContactsData,
  SettingsControllerGetContactsResponses,
  SettingsControllerUpdateContactsData,
  SettingsControllerUpdateContactsResponses,
  SiteContentControllerGetAboutUsData,
  SiteContentControllerGetAboutUsResponses,
  SiteContentControllerUpdateAboutUsData,
  SiteContentControllerUpdateAboutUsResponses,
  SiteContentControllerGetAllClientsData,
  SiteContentControllerGetAllClientsResponses,
  SiteContentControllerCreateClientData,
  SiteContentControllerCreateClientResponses,
  SiteContentControllerDeleteClientData,
  SiteContentControllerDeleteClientResponses,
  SiteContentControllerGetClientData,
  SiteContentControllerGetClientResponses,
  SiteContentControllerUpdateClientData,
  SiteContentControllerUpdateClientResponses,
  CaseControllerGetData,
  CaseControllerGetResponses,
  CaseControllerGetAllData,
  CaseControllerGetAllResponses,
  CaseControllerCreateData,
  CaseControllerCreateResponses,
  CaseControllerDeleteData,
  CaseControllerDeleteResponses,
  CaseControllerUpdateData,
  CaseControllerUpdateResponses,
  CaseCategoryControllerDeleteData,
  CaseCategoryControllerDeleteResponses,
  CaseCategoryControllerGetData,
  CaseCategoryControllerGetResponses,
  CaseCategoryControllerUpdateData,
  CaseCategoryControllerUpdateResponses,
  CaseCategoryControllerGetAllData,
  CaseCategoryControllerGetAllResponses,
  CaseCategoryControllerCreateData,
  CaseCategoryControllerCreateResponses,
  FaqControllerDeleteData,
  FaqControllerDeleteResponses,
  FaqControllerGetData,
  FaqControllerGetResponses,
  FaqControllerUpdateData,
  FaqControllerUpdateResponses,
  FaqControllerGetAllData,
  FaqControllerGetAllResponses,
  FaqControllerCreateData,
  FaqControllerCreateResponses,
  ReviewsControllerDeleteData,
  ReviewsControllerDeleteResponses,
  ReviewsControllerGetData,
  ReviewsControllerGetResponses,
  ReviewsControllerUpdateData,
  ReviewsControllerUpdateResponses,
  ReviewsControllerGetAllData,
  ReviewsControllerGetAllResponses,
  ReviewsControllerCreateData,
  ReviewsControllerCreateResponses,
  ArticlesControllerGetData,
  ArticlesControllerGetResponses,
  ArticlesControllerGetAllData,
  ArticlesControllerGetAllResponses,
  ArticlesControllerCreateData,
  ArticlesControllerCreateResponses,
  ArticlesControllerDeleteData,
  ArticlesControllerDeleteResponses,
  ArticlesControllerUpdateData,
  ArticlesControllerUpdateResponses,
  ArticleCategoryControllerDeleteData,
  ArticleCategoryControllerDeleteResponses,
  ArticleCategoryControllerGetData,
  ArticleCategoryControllerGetResponses,
  ArticleCategoryControllerUpdateData,
  ArticleCategoryControllerUpdateResponses,
  ArticleCategoryControllerGetAllData,
  ArticleCategoryControllerGetAllResponses,
  ArticleCategoryControllerCreateData,
  ArticleCategoryControllerCreateResponses,
  FeedbackControllerFindAllData,
  FeedbackControllerFindAllResponses,
  FeedbackControllerCreateData,
  FeedbackControllerCreateResponses,
  FeedbackControllerRemoveData,
  FeedbackControllerRemoveResponses,
  FeedbackControllerRemoveErrors,
  FeedbackControllerFindOneData,
  FeedbackControllerFindOneResponses,
  FeedbackControllerFindOneErrors,
  FeedbackControllerMarkWatchedData,
  FeedbackControllerMarkWatchedResponses,
  FeedbackControllerMarkWatchedErrors,
  JobControllerFindAllData,
  JobControllerFindAllResponses,
  JobControllerCreateData,
  JobControllerCreateResponses,
  JobControllerRemoveData,
  JobControllerRemoveResponses,
  JobControllerRemoveErrors,
  JobControllerFindOneData,
  JobControllerFindOneResponses,
  JobControllerFindOneErrors,
  JobControllerMarkWatchedData,
  JobControllerMarkWatchedResponses,
  JobControllerMarkWatchedErrors,
  FileUploadControllerUploadFileData,
  FileUploadControllerUploadFileResponses,
  FileUploadControllerUploadFileErrors,
  FileUploadControllerUploadPublicFileData,
  FileUploadControllerUploadPublicFileResponses,
  FileUploadControllerUploadPublicFileErrors,
  FileUploadControllerDeleteFileData,
  FileUploadControllerDeleteFileResponses,
  FileUploadControllerDeleteFileErrors,
  FileUploadControllerGetFileData,
  FileUploadControllerGetFileResponses,
  FileUploadControllerGetFileErrors,
  FileUploadControllerGetPublicFileData,
  FileUploadControllerGetPublicFileResponses,
  FileUploadControllerGetPublicFileErrors,
  DocsControllerGetPrivacyPolicyData,
  DocsControllerGetPrivacyPolicyResponses,
  DocsControllerUpdatePrivacyPolicyData,
  DocsControllerUpdatePrivacyPolicyResponses,
  DocsControllerGetCookiesPolicyData,
  DocsControllerGetCookiesPolicyResponses,
  DocsControllerUpdateCookiesPolicyData,
  DocsControllerUpdateCookiesPolicyResponses,
  DocsControllerGetPersonalDataPolicyData,
  DocsControllerGetPersonalDataPolicyResponses,
  DocsControllerUpdatePersonalDataPolicyData,
  DocsControllerUpdatePersonalDataPolicyResponses,
  SkillsControllerGetSkillsData,
  SkillsControllerGetSkillsResponses,
  SkillsControllerUpdateSkillsData,
  SkillsControllerUpdateSkillsResponses,
  ServicesControllerDeleteData,
  ServicesControllerDeleteResponses,
  ServicesControllerGetData,
  ServicesControllerGetResponses,
  ServicesControllerUpdateData,
  ServicesControllerUpdateResponses,
  ServicesControllerGetAllData,
  ServicesControllerGetAllResponses,
  ServicesControllerCreateData,
  ServicesControllerCreateResponses,
  EmployeeControllerDeleteData,
  EmployeeControllerDeleteResponses,
  EmployeeControllerGetData,
  EmployeeControllerGetResponses,
  EmployeeControllerUpdateData,
  EmployeeControllerUpdateResponses,
  EmployeeControllerGetAllData,
  EmployeeControllerGetAllResponses,
  EmployeeControllerCreateData,
  EmployeeControllerCreateResponses,
  SitemapControllerGetSitemapDataData,
  SitemapControllerGetSitemapDataResponses,
  SitemapControllerGetSitemapDataErrors,
  StatsControllerGetStatsData,
  StatsControllerGetStatsResponses,
} from './types.gen'
import { client as _heyApiClient } from './client.gen'

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * User login
 */
export const authControllerLogin = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerLoginData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<AuthControllerLoginResponses, unknown, ThrowOnError>({
    url: '/api/auth/login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Refresh access token
 */
export const authControllerRefreshToken = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerRefreshTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<AuthControllerRefreshTokenResponses, unknown, ThrowOnError>({
    url: '/api/auth/refresh-token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get current user profile
 */
export const authControllerGetCurrentUser = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerGetCurrentUserData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<AuthControllerGetCurrentUserResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/auth/profile',
    ...options,
  })
}

/**
 * Get site settings
 */
export const settingsControllerGetContacts = <ThrowOnError extends boolean = false>(
  options?: Options<SettingsControllerGetContactsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<SettingsControllerGetContactsResponses, unknown, ThrowOnError>({
    url: '/api/settings/contacts',
    ...options,
  })
}

/**
 * Update site settings
 */
export const settingsControllerUpdateContacts = <ThrowOnError extends boolean = false>(
  options: Options<SettingsControllerUpdateContactsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<SettingsControllerUpdateContactsResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/settings/contacts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get about us information
 */
export const siteContentControllerGetAboutUs = <ThrowOnError extends boolean = false>(
  options?: Options<SiteContentControllerGetAboutUsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<SiteContentControllerGetAboutUsResponses, unknown, ThrowOnError>({
    url: '/api/site-content/about-us',
    ...options,
  })
}

/**
 * Update about us information
 */
export const siteContentControllerUpdateAboutUs = <ThrowOnError extends boolean = false>(
  options: Options<SiteContentControllerUpdateAboutUsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<SiteContentControllerUpdateAboutUsResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/site-content/about-us',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get all clients
 */
export const siteContentControllerGetAllClients = <ThrowOnError extends boolean = false>(
  options?: Options<SiteContentControllerGetAllClientsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<SiteContentControllerGetAllClientsResponses, unknown, ThrowOnError>({
    url: '/api/site-content/clients',
    ...options,
  })
}

/**
 * Create new client
 */
export const siteContentControllerCreateClient = <ThrowOnError extends boolean = false>(
  options: Options<SiteContentControllerCreateClientData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<SiteContentControllerCreateClientResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/site-content/clients',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete client
 */
export const siteContentControllerDeleteClient = <ThrowOnError extends boolean = false>(
  options: Options<SiteContentControllerDeleteClientData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<SiteContentControllerDeleteClientResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/site-content/clients/{id}',
    ...options,
  })
}

/**
 * Get client by ID
 */
export const siteContentControllerGetClient = <ThrowOnError extends boolean = false>(
  options: Options<SiteContentControllerGetClientData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<SiteContentControllerGetClientResponses, unknown, ThrowOnError>({
    url: '/api/site-content/clients/{id}',
    ...options,
  })
}

/**
 * Update client
 */
export const siteContentControllerUpdateClient = <ThrowOnError extends boolean = false>(
  options: Options<SiteContentControllerUpdateClientData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<SiteContentControllerUpdateClientResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/site-content/clients/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get a case by slug
 */
export const caseControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<CaseControllerGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<CaseControllerGetResponses, unknown, ThrowOnError>({
    url: '/api/cases/{slug}',
    ...options,
  })
}

/**
 * Get all articles
 */
export const caseControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<CaseControllerGetAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CaseControllerGetAllResponses, unknown, ThrowOnError>({
    url: '/api/cases',
    ...options,
  })
}

/**
 * Create a new case
 */
export const caseControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CaseControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<CaseControllerCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/cases',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete a case
 */
export const caseControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<CaseControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<CaseControllerDeleteResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/cases/{id}',
    ...options,
  })
}

/**
 * Update a case
 */
export const caseControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CaseControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<CaseControllerUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/cases/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete category
 */
export const caseCategoryControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<CaseCategoryControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<CaseCategoryControllerDeleteResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/case-categories/{id}',
    ...options,
  })
}

/**
 * Get category by ID with cases
 */
export const caseCategoryControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<CaseCategoryControllerGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<CaseCategoryControllerGetResponses, unknown, ThrowOnError>({
    url: '/api/case-categories/{id}',
    ...options,
  })
}

/**
 * Update category
 */
export const caseCategoryControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CaseCategoryControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<CaseCategoryControllerUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/case-categories/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get all categories with cases
 */
export const caseCategoryControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<CaseCategoryControllerGetAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CaseCategoryControllerGetAllResponses, unknown, ThrowOnError>({
    url: '/api/case-categories',
    ...options,
  })
}

/**
 * Create new category
 */
export const caseCategoryControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CaseCategoryControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<CaseCategoryControllerCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/case-categories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete FAQ
 */
export const faqControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<FaqControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<FaqControllerDeleteResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/faq/{id}',
    ...options,
  })
}

/**
 * Get FAQ by ID
 */
export const faqControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<FaqControllerGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<FaqControllerGetResponses, unknown, ThrowOnError>({
    url: '/api/faq/{id}',
    ...options,
  })
}

/**
 * Update FAQ
 */
export const faqControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FaqControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<FaqControllerUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/faq/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get all FAQs
 */
export const faqControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<FaqControllerGetAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<FaqControllerGetAllResponses, unknown, ThrowOnError>({
    url: '/api/faq',
    ...options,
  })
}

/**
 * Create FAQ
 */
export const faqControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<FaqControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<FaqControllerCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/faq',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete review
 */
export const reviewsControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<ReviewsControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<ReviewsControllerDeleteResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/reviews/{id}',
    ...options,
  })
}

/**
 * Get review by ID
 */
export const reviewsControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<ReviewsControllerGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ReviewsControllerGetResponses, unknown, ThrowOnError>({
    url: '/api/reviews/{id}',
    ...options,
  })
}

/**
 * Update review
 */
export const reviewsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ReviewsControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<ReviewsControllerUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/reviews/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get all reviews
 */
export const reviewsControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<ReviewsControllerGetAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ReviewsControllerGetAllResponses, unknown, ThrowOnError>({
    url: '/api/reviews',
    ...options,
  })
}

/**
 * Create review
 */
export const reviewsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ReviewsControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ReviewsControllerCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/reviews',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get article by slug
 */
export const articlesControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<ArticlesControllerGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ArticlesControllerGetResponses, unknown, ThrowOnError>({
    url: '/api/articles/{slug}',
    ...options,
  })
}

/**
 * Get all articles
 */
export const articlesControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<ArticlesControllerGetAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ArticlesControllerGetAllResponses, unknown, ThrowOnError>({
    url: '/api/articles',
    ...options,
  })
}

/**
 * Create article
 */
export const articlesControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ArticlesControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ArticlesControllerCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/articles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete article
 */
export const articlesControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<ArticlesControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<ArticlesControllerDeleteResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/articles/{id}',
    ...options,
  })
}

/**
 * Update article
 */
export const articlesControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ArticlesControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<ArticlesControllerUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/articles/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete category
 */
export const articleCategoryControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<ArticleCategoryControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<ArticleCategoryControllerDeleteResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/article-categories/{id}',
    ...options,
  })
}

/**
 * Get category by ID
 */
export const articleCategoryControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<ArticleCategoryControllerGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ArticleCategoryControllerGetResponses, unknown, ThrowOnError>({
    url: '/api/article-categories/{id}',
    ...options,
  })
}

/**
 * Update category
 */
export const articleCategoryControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ArticleCategoryControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<ArticleCategoryControllerUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/article-categories/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get all categories
 */
export const articleCategoryControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<ArticleCategoryControllerGetAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ArticleCategoryControllerGetAllResponses, unknown, ThrowOnError>({
    url: '/api/article-categories',
    ...options,
  })
}

/**
 * Create new category
 */
export const articleCategoryControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ArticleCategoryControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ArticleCategoryControllerCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/article-categories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get all feedback requests
 */
export const feedbackControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<FeedbackControllerFindAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<FeedbackControllerFindAllResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/feedback',
    ...options,
  })
}

/**
 * Send feedback request
 */
export const feedbackControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<FeedbackControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<FeedbackControllerCreateResponses, unknown, ThrowOnError>({
    url: '/api/feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete feedback request by ID
 */
export const feedbackControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<FeedbackControllerRemoveData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    FeedbackControllerRemoveResponses,
    FeedbackControllerRemoveErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/feedback/{id}',
    ...options,
  })
}

/**
 * Get feedback request by ID
 */
export const feedbackControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<FeedbackControllerFindOneData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    FeedbackControllerFindOneResponses,
    FeedbackControllerFindOneErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/feedback/{id}',
    ...options,
  })
}

/**
 * Mark feedback request as watched by ID
 */
export const feedbackControllerMarkWatched = <ThrowOnError extends boolean = false>(
  options: Options<FeedbackControllerMarkWatchedData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    FeedbackControllerMarkWatchedResponses,
    FeedbackControllerMarkWatchedErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/feedback/watch/{id}',
    ...options,
  })
}

/**
 * Get all job requests
 */
export const jobControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<JobControllerFindAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<JobControllerFindAllResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/job-requests',
    ...options,
  })
}

/**
 * Send job application request
 */
export const jobControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<JobControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<JobControllerCreateResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/job-requests',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })
}

/**
 * Delete job request by ID
 */
export const jobControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<JobControllerRemoveData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    JobControllerRemoveResponses,
    JobControllerRemoveErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/job-requests/{id}',
    ...options,
  })
}

/**
 * Get job request by ID
 */
export const jobControllerFindOne = <ThrowOnError extends boolean = false>(
  options: Options<JobControllerFindOneData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<JobControllerFindOneResponses, JobControllerFindOneErrors, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/job-requests/{id}',
      ...options,
    },
  )
}

/**
 * Mark job request as watched by ID
 */
export const jobControllerMarkWatched = <ThrowOnError extends boolean = false>(
  options: Options<JobControllerMarkWatchedData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    JobControllerMarkWatchedResponses,
    JobControllerMarkWatchedErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/job-requests/watch/{id}',
    ...options,
  })
}

/**
 * Upload file (All users). No auth required.
 * Upload files to the server. Supported formats: images (JPEG, PNG, GIF), PDF, DOC, DOCX.
 */
export const fileUploadControllerUploadFile = <ThrowOnError extends boolean = false>(
  options: Options<FileUploadControllerUploadFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    FileUploadControllerUploadFileResponses,
    FileUploadControllerUploadFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/api/files/public',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })
}

/**
 * Upload file (Admin only). Auth required.
 * Upload files to the server. Admin only. Supported formats: images (JPEG, PNG, GIF), PDF, DOC, DOCX.
 */
export const fileUploadControllerUploadPublicFile = <ThrowOnError extends boolean = false>(
  options: Options<FileUploadControllerUploadPublicFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    FileUploadControllerUploadPublicFileResponses,
    FileUploadControllerUploadPublicFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/files',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })
}

/**
 * Delete file
 * remove file from server. Admin only.
 */
export const fileUploadControllerDeleteFile = <ThrowOnError extends boolean = false>(
  options: Options<FileUploadControllerDeleteFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    FileUploadControllerDeleteFileResponses,
    FileUploadControllerDeleteFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/files/{filename}',
    ...options,
  })
}

/**
 * Get file
 * Download file by filename. Admin only access.
 */
export const fileUploadControllerGetFile = <ThrowOnError extends boolean = false>(
  options: Options<FileUploadControllerGetFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    FileUploadControllerGetFileResponses,
    FileUploadControllerGetFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/files/{filename}',
    ...options,
  })
}

/**
 * Get file
 * Download file by filename. Public access.
 */
export const fileUploadControllerGetPublicFile = <ThrowOnError extends boolean = false>(
  options: Options<FileUploadControllerGetPublicFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    FileUploadControllerGetPublicFileResponses,
    FileUploadControllerGetPublicFileErrors,
    ThrowOnError
  >({
    url: '/api/files/public/{filename}',
    ...options,
  })
}

/**
 * Get privacy policy
 */
export const docsControllerGetPrivacyPolicy = <ThrowOnError extends boolean = false>(
  options?: Options<DocsControllerGetPrivacyPolicyData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<DocsControllerGetPrivacyPolicyResponses, unknown, ThrowOnError>({
    url: '/api/docs/privacy-policy',
    ...options,
  })
}

/**
 * Update privacy policy
 */
export const docsControllerUpdatePrivacyPolicy = <ThrowOnError extends boolean = false>(
  options: Options<DocsControllerUpdatePrivacyPolicyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<DocsControllerUpdatePrivacyPolicyResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/docs/privacy-policy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get cookies policy
 */
export const docsControllerGetCookiesPolicy = <ThrowOnError extends boolean = false>(
  options?: Options<DocsControllerGetCookiesPolicyData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<DocsControllerGetCookiesPolicyResponses, unknown, ThrowOnError>({
    url: '/api/docs/cookies-policy',
    ...options,
  })
}

/**
 * Update cookies policy
 */
export const docsControllerUpdateCookiesPolicy = <ThrowOnError extends boolean = false>(
  options: Options<DocsControllerUpdateCookiesPolicyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<DocsControllerUpdateCookiesPolicyResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/docs/cookies-policy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get personal data policy
 */
export const docsControllerGetPersonalDataPolicy = <ThrowOnError extends boolean = false>(
  options?: Options<DocsControllerGetPersonalDataPolicyData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<DocsControllerGetPersonalDataPolicyResponses, unknown, ThrowOnError>({
    url: '/api/docs/personal-data',
    ...options,
  })
}

/**
 * Update personal data policy
 */
export const docsControllerUpdatePersonalDataPolicy = <ThrowOnError extends boolean = false>(
  options: Options<DocsControllerUpdatePersonalDataPolicyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<DocsControllerUpdatePersonalDataPolicyResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/docs/personal-data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get skills configuration
 */
export const skillsControllerGetSkills = <ThrowOnError extends boolean = false>(
  options?: Options<SkillsControllerGetSkillsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<SkillsControllerGetSkillsResponses, unknown, ThrowOnError>({
    url: '/api/skills',
    ...options,
  })
}

/**
 * Update skills configuration
 */
export const skillsControllerUpdateSkills = <ThrowOnError extends boolean = false>(
  options: Options<SkillsControllerUpdateSkillsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<SkillsControllerUpdateSkillsResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/skills',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete service
 */
export const servicesControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<ServicesControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<ServicesControllerDeleteResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/services/{id}',
    ...options,
  })
}

/**
 * Get service by ID
 */
export const servicesControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<ServicesControllerGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ServicesControllerGetResponses, unknown, ThrowOnError>({
    url: '/api/services/{id}',
    ...options,
  })
}

/**
 * Update service
 */
export const servicesControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ServicesControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<ServicesControllerUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/services/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get all services
 */
export const servicesControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<ServicesControllerGetAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ServicesControllerGetAllResponses, unknown, ThrowOnError>({
    url: '/api/services',
    ...options,
  })
}

/**
 * Create new service
 */
export const servicesControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ServicesControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ServicesControllerCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/services',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete employee
 */
export const employeeControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<EmployeeControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<EmployeeControllerDeleteResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/employees/{id}',
    ...options,
  })
}

/**
 * Get employee by ID
 */
export const employeeControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<EmployeeControllerGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<EmployeeControllerGetResponses, unknown, ThrowOnError>({
    url: '/api/employees/{id}',
    ...options,
  })
}

/**
 * Update employee
 */
export const employeeControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<EmployeeControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<EmployeeControllerUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/employees/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get all employees
 */
export const employeeControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<EmployeeControllerGetAllData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<EmployeeControllerGetAllResponses, unknown, ThrowOnError>({
    url: '/api/employees',
    ...options,
  })
}

/**
 * Create new employee
 */
export const employeeControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<EmployeeControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<EmployeeControllerCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/employees',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Generate sitemap data
 * Provides all public URLs with their last modified dates for XML sitemap generation
 */
export const sitemapControllerGetSitemapData = <ThrowOnError extends boolean = false>(
  options?: Options<SitemapControllerGetSitemapDataData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SitemapControllerGetSitemapDataResponses,
    SitemapControllerGetSitemapDataErrors,
    ThrowOnError
  >({
    url: '/api/sitemap',
    ...options,
  })
}

export const statsControllerGetStats = <ThrowOnError extends boolean = false>(
  options?: Options<StatsControllerGetStatsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<StatsControllerGetStatsResponses, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/stats',
    ...options,
  })
}
